import { createApp } from 'vue'
import { ElConfigProvider, ElDialog } from 'element-plus'
import 'element-plus/dist/index.css'

// 全局：所有弹窗默认垂直居中 + 渲染到 body 避免被父容器 overflow 裁切
ElDialog.props.alignCenter.default = true
ElDialog.props.appendToBody.default = true

import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/styles/index.scss'
import { permissionDirective } from '@/directives/permission'

const app = createApp(App)
app.component('ElConfigProvider', ElConfigProvider)

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component as never)
}

// 注册 v-permission 指令
app.directive('permission', permissionDirective)

app.use(router)
app.use(store)
app.mount('#app')